var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEconomics = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Analytics-Graph-Bar--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Analytics Graph Bar Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.25 21h3.5a0.25 0.25 0 0 0 0.25 -0.25v-2a1 1 0 0 0 -1 -1H2a1 1 0 0 0 -1 1v2a0.25 0.25 0 0 0 0.25 0.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12.75a1 1 0 0 0 -1 1v7a0.25 0.25 0 0 0 0.25 0.25h3.5a0.25 0.25 0 0 0 0.25 -0.25v-7a1 1 0 0 0 -1 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14.75a1 1 0 0 0 -1 1v5a0.25 0.25 0 0 0 0.25 0.25h3.5a0.25 0.25 0 0 0 0.25 -0.25v-5a1 1 0 0 0 -1 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 7.75a1 1 0 0 0 -1 1v12a0.25 0.25 0 0 0 0.25 0.25h3.5a0.25 0.25 0 0 0 0.25 -0.25v-12a1 1 0 0 0 -1 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 -0.25a2 2 0 0 0 -2 2 2.31 2.31 0 0 0 0.05 0.46 0.25 0.25 0 0 1 -0.05 0.22l-3.26 3.8a0.26 0.26 0 0 1 -0.25 0.08 2 2 0 0 0 -0.49 -0.06 2 2 0 0 0 -1.42 0.59 0.23 0.23 0 0 1 -0.25 0.06l-2.18 -0.72A0.25 0.25 0 0 1 11 6a2 2 0 0 0 -4 0.28 2.24 2.24 0 0 0 0 0.46A0.23 0.23 0 0 1 7 7L4.07 9.38a0.25 0.25 0 0 1 -0.26 0A2 2 0 1 0 5 11.25a2.31 2.31 0 0 0 0 -0.46 0.24 0.24 0 0 1 0 -0.25l2.9 -2.42a0.25 0.25 0 0 1 0.26 0 2 2 0 0 0 0.84 0.13 2 2 0 0 0 1.42 -0.59 0.23 0.23 0 0 1 0.25 -0.06l2.18 0.72a0.25 0.25 0 0 1 0.17 0.21 2 2 0 1 0 3.82 -1.06 0.25 0.25 0 0 1 0 -0.26l3 -3.55a0.25 0.25 0 0 1 0.29 -0.07 2.1 2.1 0 0 0 0.79 0.16 2 2 0 0 0 0 -4Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 24.25h22a1 1 0 0 0 1 -1 1 1 0 0 0 -0.56 -0.9 1.05 1.05 0 0 0 -0.44 -0.1H1a1.05 1.05 0 0 0 -0.44 0.1 1 1 0 0 0 -0.56 0.9 1 1 0 0 0 1 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEconomics);
export default ForwardRef;